<template>
  <q-dialog
    v-model="dialog"
    persistent
  >
    <q-card style="width: 400px" class="pragma-black">
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma text-white">
          <span class="text-bold">Capturar imágen</span>
          <q-space></q-space>
          <q-btn
            flat
            icon="flip_camera_ios"
            @click="changeCamera()"
          ></q-btn>
          <q-btn
            icon="clear"
            flat
            color="white"
            @click="closeDialog()"
          ></q-btn>
        </q-toolbar>
      </q-card-section>
      <q-card-section>
        <div class="row full-width">
          <div class="col-xs-12" v-if="!url_image">
            <camera
              :resolution="{ width: 1000, height: 1000 }"
              ref="camera"
              autoplay
            ></camera>
          </div>
          <div class="col-xs-12" v-if="url_image">
            <q-img :src="url_image" style="width: 100%" />
          </div>
        </div>
        <div class="row full-width flex flex-center">
          <div class="col-4 q-pa-sm text-center">
            <q-btn
              icon="camera"
              round
              @click="snapshot()"
              color="positive"
              v-if="!url_image"
              :loading="loading"
            ></q-btn>
            <q-btn
              icon="save"
              round
              @click="saveImage()"
              color="positive"
              v-if="url_image"
            ></q-btn>
          </div>
          <div class="col-4 q-pa-sm text-center">
            <q-btn
              icon="refresh"
              round
              color="primary"
              :disable="!url_image"
              @click="resetCamera()"
            ></q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import Camera from "simple-vue-camera";

export default {
  components: { Camera },
  setup () {
    const bus = inject('bus')

    const dialog = ref(false)
    // Variable de la camara
    const camera = ref(null)
    const devices = ref([])
    const device_id = ref(0)
    const url_image = ref(null)
    const save_image = ref(null)
    const loading = ref(false)

    // Métodos y funciones del componente
    const snapshot = async () => {
      loading.value = true
      save_image.value = await camera.value.snapshot({ width: 1000, height: 1000 });
      
      // To show the screenshot with an image tag, create a url
      url_image.value = URL.createObjectURL(save_image.value);
      loading.value = false
    }

    const resetCamera = () => {
      url_image.value = null
    }

    const closeDialog = () => {
      url_image.value = null
      devices.value = []
      device_id.value = 0
      dialog.value = false
    }

    const changeCamera = async () => {
      devices.value = await camera.value.devices(["videoinput"])
      if (device_id.value < devices.value.length - 1) {
        device_id.value++
        await camera.value.changeCamera(devices.value[device_id.value].deviceId);
      } else {
        device_id.value = -1
        changeCamera()
      }
    }

    const saveImage = () => {
      bus.emit('closeDialogSnapPhoto', save_image.value)
      closeDialog()
    }

    // Creación del componente
    bus.on('openDialogSnapPhoto', async () => {
      dialog.value = true
    })
    return {
      dialog,
      camera,
      snapshot,
      closeDialog,
      changeCamera,
      url_image,
      resetCamera,
      saveImage,
      loading
    }
  }
}
</script>

<style>

</style>